@if (loading) {
  <div class="hc-loading">
    <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
  </div>
}

@if (!loading && notFound) {
  <div class="hc-notfound">
    @if (!embedded) {
      <button type="button" class="hc-back" (click)="back.emit()">← Back</button>
    }
    <h1>Article not found</h1>
    <p>This article may have moved or you may not have access to it.</p>
  </div>
}

@if (!loading && article) {
  <div class="hc-article-layout">
    <article>
      @if (!embedded) {
        <button type="button" class="hc-back" (click)="back.emit()">← Back</button>
      }
      <h1>{{ article.title }}</h1>
      @for (part of parts; track $index) {
        @if (part.kind === 'markdown') {
          <markdown [data]="part.markdown" (ready)="onMarkdownReady()"></markdown>
        } @else if (part.kind === 'videofile') {
          <div class="hc-video">
            <video [src]="part.videoSrc" controls preload="metadata" playsinline></video>
          </div>
        } @else {
          <div class="hc-video">
            <iframe
              [src]="part.video"
              title="Video"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
        }
      }

      <div class="hc-feedback">
        @switch (feedbackState) {
          @case ('idle') {
            <div class="hc-feedback-row">
              <span class="hc-feedback-q">Was this helpful?</span>
              <button type="button" class="hc-feedback-btn" (click)="voteHelpful()">👍 Yes</button>
              <button type="button" class="hc-feedback-btn" (click)="voteNotHelpful()">👎 No</button>
            </div>
          }
          @case ('comment') {
            <p class="hc-feedback-q">Sorry about that — what was missing? (optional)</p>
            <textarea
              class="hc-feedback-comment"
              rows="3"
              [value]="feedbackComment"
              (input)="feedbackComment = $any($event.target).value"
              placeholder="Tell us how we can improve this article"
            ></textarea>
            <div class="hc-feedback-actions">
              <button type="button" class="hc-feedback-submit" (click)="submitNotHelpful()">Send feedback</button>
            </div>
          }
          @case ('done') {
            <span class="hc-feedback-thanks">✓ Thanks for your feedback!</span>
          }
        }
      </div>
    </article>

    @if (showToc) {
      <nav class="hc-toc">
        <p class="hc-toc-title">On this page</p>
        <ul>
          @for (item of tocItems; track item.id) {
            <li [class.hc-toc-sub]="item.level === 3">
              <button type="button" [class.active]="item.id === activeId" (click)="scrollTo(item.id)">
                {{ item.text }}
              </button>
            </li>
          }
        </ul>
      </nav>
    }
  </div>
}
